import keyBy from 'lodash/keyBy';

import { BARRED_LOCATIONS_LOADED } from '../constants';

export const INITIAL_STATE = {
  byId: {},
  data: [],
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case BARRED_LOCATIONS_LOADED: {
      const byId = { ...state.byId, ...keyBy(payload.data, 'id') };
      return {
        ...state,
        byId,
        data: Object.values(byId),
      };
    }

    default: {
      return state;
    }
  }
};

export default reducer;
